<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="home-box">
      <div class="honey-box">
        <div class="text-1">Rasanya tidak lagi monoton. Bumbu kami menambah warna pada makanan Anda.</div>
        <div class="text-2">Lini produk kami mencakup beragam rasa, dari klasik hingga inovatif, memungkinkan Anda mengubah selera dengan mudah dan membuat setiap hidangan penuh kejutan.</div>
      </div>
    </div>
    <div class="makanan-1">
      <div class="makanan-box">
        <div>Makanan enak dimulai dengan memilih bumbu kami.</div>
        <p>Bumbu kami membuat perjalanan gastronomi Anda semakin mengasyikkan. Baik itu makan malam keluarga atau kumpul bersama teman, produk kami dapat menambahkan sentuhan unik pada hidangan Anda.</p>
      </div>
      <div class="makanan-img">
        <img src="../assets/home-2.png" alt="">
        <img src="../assets/home-3.png" alt="">
      </div>
    </div>

    <div class="makanan-2">
      <img src="../assets/home-4.png" alt="">
      <div class="makanan-text">
        <div>Jiwa dari makanan gourmet terletak pada bumbu kami.</div>
        <p>Produk kami diformulasikan dengan cermat untuk memberikan rasa unik ke dalam masakan Anda, menjadikan Anda bintang di dapur rumah Anda.</p>
        <p>Disiapkan dengan hati-hati, setiap hidangan menjadi pesta untuk dicicipi. Hidupkan hidangan Anda dan buat selera Anda menari.</p>
      </div>
    </div>

    <div class="makanan-3">
      <div class="text-1-left">
        <div class="title">Makanan enak dimulai dengan memilih bumbu kami.</div>
        <div class="sbtitle">Bumbu kami membuat perjalanan gastronomi Anda semakin mengasyikkan. Baik itu makan malam keluarga atau kumpul bersama teman, produk kami dapat menambahkan sentuhan unik pada hidangan Anda.</div>
        <div class="list-box">
          <div class="team">
            1000+
            <p>Dijual di toko</p>
          </div>
          <div class="team">
            80000+
            <p>Direkomendasikan oleh kepercayaan keluarga</p>
          </div>
        </div>
      </div>
      <div class="img-1 img-box">
        <div class="img-text">
          <p>pilihan ganda</p>
          Kami memiliki beragam bumbu yang dapat digunakan oleh keluarga dalam skenario berbeda dan menyelesaikan pencocokan rasa berbagai hidangan di dapur, menjadikan setiap hidangan penuh warna.
        </div>
      </div>
      <div class="img-2 img-box">
        <div class="img-text">
          <p>Lezat secara daring</p>
          Berbagai bumbu kami memiliki rasa yang kaya dan sangat disukai banyak orang. Mereka juga dapat digunakan dengan baik bersama-sama. Ada banyak bumbu yang dapat digunakan langsung dengan makanan.
        </div>
      </div>
    </div>

    <div class="makanan-4">
      <div>Bumbu kami membuat makanan Anda lebih istimewa.</div>
      <p>Kami berusaha keras untuk menciptakan cita rasa unik untuk hidangan Anda, menjadikannya menonjol dari yang lain dan menjadi pusat perhatian.</p>
    </div>

    <div class="makanan-5">
      <div class="item-box">
        <img src="../assets/home-7.png" alt="">
        <div>berbagai jenis</div>
        <p>Produk kami tidak hanya mewarisi teknik modulasi tradisional, tetapi juga mengadopsi teknologi terkini. Kami juga mengoptimalkan dan memperbarui bumbu asli untuk memberikan lebih banyak pilihan bumbu kepada pengguna.</p>
        <div class="date-box"><img src="../assets/home-10.png" alt=""> 2024/5/12</div>
      </div>
      <div class="item-box">
        <img src="../assets/home-8.png" alt="">
        <div>hijau sehat</div>
        <p>Produk kami menggunakan bahan-bahan alami berkualitas tinggi untuk menjamin rasa dan kualitas. Kontrol secara ketat proses pengadaan bahan baku dan pilih bahan baku dari asal berkualitas tinggi di seluruh dunia untuk memastikan kesegaran dan kemurnian produk.</p>
        <div class="date-box"><img src="../assets/home-10.png" alt=""> 2024/5/12</div>
      </div>
      <div class="item-box">
        <img src="../assets/home-9.png" alt="">
        <div>Jumlah besar dan harga bagus</div>
        <p>Produk kami sangat populer dan dapat dibeli di sebagian besar supermarket, dengan diskon tidak teratur.</p>
        <div class="date-box"><img src="../assets/home-10.png" alt=""> 2024/5/12</div>
      </div>
    </div>




    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>


<style lang="less" scoped>
.home-box {
  background-image: url(../assets/home-1.png);
  background-size: 100% 100%;
  width: 100%;
  height: 900px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .honey-box {
    width: 847px;
    font-weight: 400;
    font-size: 22px;
    color: #FFFFFF;
    margin-left: 360px;

    .text-1 {
      font-weight: bold;
      font-size: 52px;
    }
  }
}

.makanan-1 {
  padding: 150px 360px;

  .makanan-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 52px;
    color: #333333;

    div {
      width: 700px;
    }

    p {
      font-weight: 400;
      font-size: 20px;
      color: #888888;
      width: 370px;
    }
  }

  .makanan-img {
    margin-top: 51px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 538px;
    }
  }
}

.makanan-2 {
  padding: 92px 360px;
  background: #FFF8ED;
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    width: 565px;
  }

  .makanan-text {
    width: 500px;

    div {
      font-weight: bold;
      font-size: 46px;
      color: #333333;
    }

    p {
      font-weight: 500;
      font-size: 20px;
      color: #999999;
      margin-top: 22px;
    }
  }
}

.makanan-3 {
  padding: 150px 360px;
  display: flex;
  align-items: self-start;
  justify-content: space-between;

  .text-1-left {
    width: 450px;

    .title {
      font-weight: bold;
      font-size: 52px;
      color: #333333;
    }

    .sbtitle {
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      margin-top: 12px;
    }

    .list-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 39px;

      .team {
        width: 211px;
        height: 128px;
        background: #FFFFFF;
        box-shadow: 0px 4px 32px 0px rgba(12, 77, 46, 0.1);
        border-radius: 20px 20px 20px 20px;
        font-weight: bold;
        font-size: 39px;
        color: #FFA200;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        p {
          font-weight: 600;
          font-size: 14px;
          color: #333333;
          text-align: center;
        }
      }

    }
  }

  .img-box {
    width: 333px;
    height: 350px;
    background-size: 100% 100%;
    display: flex;
    // align-items: center;
    justify-content: center;

    .img-text {
      width: 203px;
      height: 148px;
      background: #FFA200;
      border-radius: 7px 7px 7px 7px;
      padding: 30px;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
      margin-top: 80%;

      p {
        font-weight: 600;
        font-size: 18px;
        color: #FFFFFF;
      }
    }
  }

  .img-1 {
    background-image: url(../assets/home-5.png);
  }

  .img-2 {
    background-image: url(../assets/home-6.png);
  }

}

.makanan-4 {
  padding: 0px 360px;

  div {
    font-weight: bold;
    font-size: 46px;
    color: #333333;
    width: 600px;
  }

  p {
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    margin-top: 30px;
    width: 600px;
  }
}

.makanan-5 {
  padding: 150px 360px;
  display: flex;
  align-items: self-start;
  justify-content: space-between;

  .item-box {
    width: 390px;
    min-height: 242px;
    background: #FFF8ED;
    border-radius: 28px;

    img {
      width: 390px;
    }

    div {
      padding: 0px 30px;
      margin-top: 47px;
      font-weight: 500;
      font-size: 26px;
      color: #333333;
    }

    p {
      padding: 0px 30px;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      margin-top: 17px;
    }

    .date-box {
      padding: 30px;
      font-weight: 500;
      font-size: 19px;
      color: #333333;
      display: flex;
      align-items: center;
      margin-top: 0px;

      img {
        width: 32px;
        margin-right: 10px;
      }
    }
  }
}
</style>
